import { combineReducers } from 'redux';

import editProduction from './editproduction/reducer';
import manageProduction from './manageproduction/reducer';

export default combineReducers({
  editProduction,
  manageProduction,
});



// WEBPACK FOOTER //
// ./src/pages/manageproduction/state/reducer.js